<app-header *ngIf="!isLoginRoute()"></app-header>

<app-spinner *ngIf="isLoading"></app-spinner>

<ng-container *ngIf="step$ | async as step">
  <app-stepper [step]="step" [max]="5"></app-stepper>
</ng-container>

<app-notification></app-notification>

<router-outlet></router-outlet>